import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Box, Typography,} from '@mui/material'
import { CustomButton, HumbeeTabs, TextField } from '../../../v2/MUI_custom_component';
import { IDLength } from '../../../utils/settings';
import { useLocation, useNavigate } from 'react-router-dom';
import customToast from '../../../utils/customToast';
import { GstUserGstDataFetch, GstUserPanDataFetch } from '../../../v2/Onboarding/auth/action';

const GstPanInput = () => {
    const location = useLocation();
    const {show_gst_input, gst_flow , operational_details} = useSelector(state => state.FirmOnboardingReducer);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [currentTab, setCurrentTab] = useState(gst_flow ? 0 : 1);
    const [gstValue, setGstValue] = useState("");
    const [panValue, setPanValue] = useState("");
    const [isValid, setIsValid] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const detailPage = location?.state?.detailPage || false;
    const autofillgst = operational_details?.gst_number ? operational_details.gst_number : "";
    const autofillpan = operational_details?.pan_number ? operational_details.pan_number : "";
    useEffect(() => {
        if (detailPage) {
            setGstValue(autofillgst);
            setPanValue(autofillpan);
        }
    }, [autofillgst, autofillpan, detailPage]);
    const tabs = [{ label: "GST", value: "gst" }, { label: "PAN", value: "pan" }];
    const validateGST = (gst) => {
        if (gst.length !== IDLength.GST) return "Please enter a valid GST number (15 characters)";
        return "";
    };
    const validatePAN = (pan) => {
        if (pan.length !== IDLength.PAN) return "Please enter a valid PAN number (10 characters)";
        return "";
    };
    const GetGSTDetails = async (gstNumber) => {
        setIsLoading(true);
        const { error, message, data } = await GstUserGstDataFetch(gstNumber);
        setIsLoading(false);
        
        if (!error && data && Object.keys(data).length) {
            const gstDetails = {
                gst_number: gstNumber,
                pan_number: data?.pan || null,
                firm_name: data?.trade_name || data?.legal_name || null,
                address_line_1: data.principal_address?.address_line_1 || null,
                address_line_2: data.principal_address?.address_line_2 + data.principal_address?.address_line_3 || null,
                state_id: data.principal_address?.state_id || null,
                state_name: data.principal_address?.state_name || null,
                pincode_id: data.principal_address?.pincode_id || null,
                district_id: data.principal_address?.district_id || null,
                district_name: data.principal_address?.district_name || null,
                location_id: data.principal_address?.location_id || null,
                location_name: data.principal_address?.location_name || null,
            };
            dispatch({ type: 'SET_GST_DETAILS', payload: gstDetails });
            dispatch({ type: 'SET_OPERATIONAL_DETAILS', payload: gstDetails });
            dispatch({ type: 'SET_GST_NUMBER', payload: gstNumber });
            return true;
        } else {
            customToast.error(message);
            return false;
        }
    };
    const GetPanDetails = async (panNumber) => {
        setIsLoading(true);
        const { error, message, data } = await GstUserPanDataFetch(panNumber);
        setIsLoading(false);
        
        if (!error && data) {
            const panDetails = {
                pan_number: panNumber,
                firm_name: data.name || null,
                address_line_1: data.address_data?.line_1 || null,
                address_line_2: data.address_data?.line_2 || null,
                state_id: data.address_data?.state_id || null,
                state_name: data.address_data?.state || null,
                district_id: data.address_data?.district_id || null,
                district_name: data.address_data?.district_name || null,
                location_id: null,
                location_name: null,
                pincode_id: data.address_data?.pincode || null,
            };
            dispatch({ type: 'SET_PAN_DETAILS', payload: panDetails });
            dispatch({ type: 'SET_OPERATIONAL_DETAILS', payload: panDetails });            return true;
        } else {
            customToast.error(message);
            return false;
        }
    };
    const handleContinue = async () => {
            dispatch({ type: 'RESET_PAN_DETAILS'});
            dispatch({ type: 'RESET_OPERATIONAL_DETAILS'});
            let success = false;
            if (show_gst_input && gstValue) {
                success = await GetGSTDetails(gstValue);
            } else {
                const currentTabValue = tabs[currentTab].value;
                if (currentTabValue === "gst" && gstValue) {
                    success = await GetGSTDetails(gstValue);
                } else if (currentTabValue === "pan" && panValue) {
                    success = await GetPanDetails(panValue);
                }
            }
            if (success) {
                navigate('/firm-onboarding/confirm-details');
            }
    };
    useEffect(() => {
        if (show_gst_input) {
            const gstErr = validateGST(gstValue);
            setIsValid(!gstErr);
        } else {
            const currentTabValue = tabs[currentTab].value;
            if (currentTabValue === "gst") {
                const gstErr = validateGST(gstValue);
                setIsValid(!gstErr);
            } else {
                const panErr = validatePAN(panValue);
                setIsValid(!panErr);
            }
        }
    }, [gstValue, panValue, currentTab, show_gst_input]);
    const handleTabChange = (event, newTab) => {
        setGstValue("");
        setPanValue("");
        dispatch({ type: 'SET_GST_FLOW', payload: newTab === 1 ? false : true });
        setCurrentTab(newTab);
    };
    if (show_gst_input) {
        return (
            <Box sx={{ display:"flex", flexDirection:"column", height: {md: '100vh'}, alignItems: {md: 'center'}, justifyContent: {md: 'center' }}}>
                <Box sx={{ display:"flex", flexDirection:"column", gap:4, width: '100%' }}>
                    <Box sx={{ display:"flex", flexDirection:"column", gap: 2, }}>
                        <TextField
                            label="GST*"
                            placeholder="Enter GST number"
                            value={gstValue || autofillgst}
                            onChange={(e) => setGstValue(e.target.value.toUpperCase())}
                            inputProps={{ maxLength: IDLength.GST, minLength: IDLength.GST }}
                            fullWidth
                            disabled={isLoading}
                        />
                        <Typography variant='body1'>
                            *GST/PAN is required to purchase & sell products on HUMBEE
                        </Typography>
                    </Box>
                    <CustomButton
                        label="Continue"
                        variant="filled"
                        fullWidth
                        disabled={!isValid || isLoading}
                        onClick={handleContinue}
                        loading={isLoading}
                    />
                </Box>
            </Box>
        )
    }
    return (
        <Box sx={{ display:"flex", flexDirection:"column", gap: 4 }}>
            <Box sx={{ display:"flex", flexDirection:"column", gap: 2 }}>
                <HumbeeTabs
                    tabsSx={{ width: 'fit-content' }}
                    tabVariant="small"
                    tabType="outlined"
                    data={tabs}
                    currentTab={currentTab}
                    onChange={handleTabChange}
                    getTabLabel={item => item.label}
                    renderTabContent={(item) => {
                        if (item.value === "gst") {
                            return (
                                <TextField
                                    label="GST*"
                                    placeholder="Enter GST number"
                                    value={gstValue || autofillgst}
                                    onChange={(e) => setGstValue(e.target.value.toUpperCase())}
                                    inputProps={{ maxLength: IDLength.GST, minLength: IDLength.GST }}
                                    fullWidth
                                    disabled={isLoading}
                                />
                            );
                        }
                        if (item.value === "pan") {
                            return (
                                <TextField
                                    label="PAN*"
                                    placeholder="Enter PAN number"
                                    value={panValue || autofillpan}
                                    onChange={(e) => setPanValue(e.target.value.toUpperCase())}
                                    inputProps={{ maxLength: IDLength.PAN, minLength: IDLength.PAN }}
                                    fullWidth
                                    disabled={isLoading}
                                />
                            );
                        }
                        return null;
                    }}
                />
                <Typography variant='body1'>
                    *GST/PAN is required to purchase & sell products on HUMBEE
                </Typography>
            </Box>
            <CustomButton
                label="Continue"
                variant="filled"
                fullWidth
                disabled={!isValid || isLoading}
                onClick={handleContinue}
                loading={isLoading}
            />
        </Box>

    );
}

export default GstPanInput